var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":_vm.id,"title":_vm.title},scopedSlots:_vm._u([{key:"modal-footer",fn:function(ref){
var ok = ref.ok;
return [_vm._t("footer"),_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":ok}},[_vm._v("OK")])]}}],null,true)},[[_vm._t("default")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }